import React from "react";

const SvgCommonFileText = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M21.414 4.914L17.086.586A2 2 0 0015.672 0H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V6.328a2 2 0 00-.586-1.414zM11 19.5H6.5a1 1 0 010-2H11a1 1 0 010 2zm4.5-4h-9a1 1 0 010-2h9a1 1 0 010 2zm0-4h-9a1 1 0 010-2h9a1 1 0 010 2z" />
  </svg>
);

export default SvgCommonFileText;
